<template>
  <v-dialog
    v-if="item"
    v-model="visible"
    :fullscreen="mobileScreen"
    max-width="700px"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs10>
            <h2 class="text-xs-left display-3 sz_grafit--text ma-0 mt-1">
              {{ $t('manage_volunteers.title') }}
            </h2>
          </v-flex>
          <v-flex xs2>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-layout
          row
          wrap
        >
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
          >
            <v-flex xs12>
              <p class="mb-0">
                {{ fullName(item) }}
              </p>
              <p class="mb-0">
                {{ fullStreet(item) }}
              </p>
              <p class="mb-0">
                {{ fullCity(item) }}
              </p>
            </v-flex>
          </v-flex>
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
            class="mt-2"
          >
            <v-flex
              sm10
              xs12
            >
              <v-autocomplete
                ref="primaryVolunteer"
                v-model="primaryVolunteerId"
                :data-vv-as="$t('label.main_volunteer')"
                :items="getPrimaryVolunteers"
                item-value="account_id"
                :label="$t('label.main_volunteer')"
                append-icon="expand_more"
                :loading="volunteersLoader"
                :filter="volunteersFilter"
                @click:append="clickAppend('primaryVolunteer')"
              >
                <template
                  slot="item"
                  slot-scope="props"
                >
                  <span :class="{ 'refused-family': props.item.rejected_this_family }">{{
                    props.item.full_name
                  }}</span>
                </template>
                <template
                  slot="selection"
                  slot-scope="props"
                >
                  {{ props.item.full_name }}
                </template>
              </v-autocomplete>
              <v-autocomplete
                ref="secondaryVolunteer"
                v-model="secondaryVolunteerId"
                :data-vv-as="$t('label.sidekick')"
                :items="getSecondaryVolunteers"
                item-value="account_id"
                item-text="full_name"
                :label="$t('label.sidekick')"
                append-icon="expand_more"
                :loading="volunteersLoader"
                :filter="volunteersFilter"
                @click:append="clickAppend('secondaryVolunteer')"
              >
                <template
                  slot="item"
                  slot-scope="props"
                >
                  {{ props.item.full_name }}
                </template>
                <template
                  slot="selection"
                  slot-scope="props"
                >
                  {{ props.item.full_name }}
                </template>
              </v-autocomplete>
            </v-flex>
          </v-flex>
          <v-flex
            sm10
            xs12
            offset-sm2
            offset-xs0
          >
            <v-flex
              sm10
              xs12
            >
              <v-layout justify-center>
                <v-btn
                  flat
                  class="text-none w-auto"
                  color="sz_violet"
                  :disabled="isDisabledClearButton"
                  @click="clearVolunteers()"
                >
                  {{ $t('buttons.clear_volunteers') }}
                </v-btn>
              </v-layout>
              <p class="mb-0 mt-3">
                {{ $t('message.volunteer_manager_help') }}
              </p>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[mobileScreen ? 'mt-2' : 'mr-3']"
          >
            <v-btn
              flat
              class="text-none"
              color="sz_violet"
              @click="closeDialog()"
            >
              <v-icon>chevron_left</v-icon>
              {{ buttonReturnText }}
            </v-btn>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :loading="assignLoader"
              :disabled="isDisabled"
              @click="save()"
            >
              {{ $t('buttons.save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import filters from '@/constants/filters';
import { mapGetters } from 'vuex';

export default {
    name: 'ManageVolunteersDialog',
    filters: {
        ...filters
    },
    props: ['show', 'item'],
    data () {
        return {
            visible: false,
            volunteersLoader: false,
            primaryVolunteerId: null,
            secondaryVolunteerId: null,
            assignLoader: false
        };
    },
    watch: {
        show (val) {
            this.visible = val;
        },
        visible (val) {
            this.$emit('show', val);
            this.primaryVolunteerId =
        this.item.primary_volunteer === null ? null : this.item.primary_volunteer.id;
            this.secondaryVolunteerId =
        this.item.secondary_volunteer === null ? null : this.item.secondary_volunteer.id;
            this.$store.commit('volunteers/setVolunteers', []);
            if (val === true) {
                this.requestVolunteers();
            }
        },
        primaryVolunteerId (val) {
            if (val === undefined) this.primaryVolunteerId = null;
        },
        secondaryVolunteerId (val) {
            if (val === undefined) this.secondaryVolunteerId = null;
        }
    },
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        },
        ...mapGetters('volunteers', ['getVolunteers']),
        getPrimaryVolunteers () {
            return this.$store.getters['volunteers/getVolunteers'].filter((el) => {
                return el.account_id !== this.secondaryVolunteerId && el.roles.includes('primary') === true;
            });
        },
        getSecondaryVolunteers () {
            return this.$store.getters['volunteers/getVolunteers'].filter((el) => {
                return el.account_id !== this.primaryVolunteerId;
            });
        },
        buttonReturnText () {
            return this.$route.name === 'family-card'
                ? this.$t('buttons.return_to_family_card')
                : this.$t('buttons.return_to_families_list');
        },
        isDisabled () {
            if (this.assignLoader) return true;
            else if (this.primaryVolunteerId === null && this.secondaryVolunteerId === null) return false;
            else if (this.primaryVolunteerId === null || this.secondaryVolunteerId === null) return true;
            return false;
        },
        isDisabledClearButton () {
            return this.primaryVolunteerId == null && this.secondaryVolunteerId == null;
        }
    },

    created () {
        this.visible = this.show;
    },
    methods: {
        clickAppend (refName) {
            const element = this.$refs[refName];
            if (element) {
                if (element.$el.classList.contains('v-input--is-focused')) {
                    element.blur();
                } else element.onClick();
            }
        },
        closeDialog () {
            this.visible = false;
            this.$store.commit('volunteers/setVolunteers', []);
        },
        fullName (item) {
            const _firstName = item.first_name !== null ? item.first_name : '';
            return _firstName + ' ' + item.last_name;
        },
        fullStreet (item) {
            const street = item.street ? item.street : '';
            const _flat = item.flat_number !== null ? '/' + item.flat_number : '';
            return street + ' ' + item.building_number + _flat;
        },
        fullCity (item) {
            return this.$options.filters.postalCode(item.postal_code) + ' ' + item.city;
        },
        save () {
            this.assign();
        },
        requestVolunteers () {
            this.$store.commit('volunteers/setVolunteers', []);
            this.volunteersLoader = true;
            this.$store
                .dispatch('volunteers/getVolunteers', this.item.family_edition_id)
                .then(({ data }) => {
                    this.$store.commit('volunteers/setVolunteers', data);
                    const primary = this.getVolunteerById(this.primaryVolunteerId);
                    const secondary = this.getVolunteerById(this.secondaryVolunteerId);
                    if (primary == null) this.primaryVolunteerId = null;
                    if (secondary == null) this.secondaryVolunteerId = null;
                    this.volunteersLoader = false;
                });
        },
        assign () {
            this.assignLoader = true;
            this.$store
                .dispatch('volunteers/assignVolunteers', {
                    id: this.item.family_edition_id,
                    data: {
                        primary_volunteer: this.primaryVolunteerId,
                        secondary_volunteer: this.secondaryVolunteerId
                    }
                })
                .then(({ data }) => {
                    this.$store.commit('family/setFamily', data);
                    this.assignTemporaryValue();
                    this.closeDialog();
                })
                .finally(() => {
                    this.assignLoader = false;
                    this.$emit('reload');
                });
        },
        assignTemporaryValue () {
            const primary = this.getVolunteerById(this.primaryVolunteerId);
            const secondary = this.getVolunteerById(this.secondaryVolunteerId);
            if (primary !== null) {
                this.$set(this.item, 'primary_volunteer', {
                    id: primary.account_id,
                    full_name: primary.full_name
                });
            } else {
                this.$set(this.item, 'primary_volunteer', null);
            }
            if (secondary !== null) {
                this.$set(this.item, 'secondary_volunteer', {
                    id: secondary.account_id,
                    full_name: secondary.full_name
                });
            } else {
                this.$set(this.item, 'secondary_volunteer', null);
            }
        },
        getVolunteerById (id) {
            if (id === null || id === undefined) return null;
            return this.getVolunteers.find((el) => {
                return el.account_id === id;
            });
        },
        volunteersFilter (item, query) {
            return item.full_name.toLocaleLowerCase().indexOf(query.toLocaleLowerCase()) > -1;
        },
        clearVolunteers () {
            this.primaryVolunteerId = null;
            this.secondaryVolunteerId = null;
        }
    }
};
</script>

<style lang="scss" scoped>
@import './src/assets/css/_variables';
.refused-family {
  &::after {
    content: ' (odrzucił)';
  }
  color: $sz_grey;
}
</style>
